module.exports = __webpack_public_path__ + "static/media/13d-04_Esperanza-y-terror-2013-405x295mm-oleo-sobre-papel.4db38601.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/13d/13d-04_Esperanza-y-terror-2013-405x295mm-oleo-sobre-papel.jpg
// module id = 142
// module chunks = 0